import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SelectInput } from '../inputs';
import { AddButton } from '../buttons';
import { FullTable } from '../table';
import { NewDragAndDrop } from './newDragAndDrop';
import { documentsHeader, loadCustomerInfoBody } from './constants';
import { screensStyle } from '../screens/styles';
import { FindLoad, FindSuccessItem } from 'utils';
import { httpRequestsOnSuccessActions } from 'store';


export const DocumentTable = (
  {
    documentsTypes,
    handleChangeStatus,
    changeStatusAction,
    handleUploadFile,
    addLoadAction,
    handleDeleteDocument,
    deleteDocAction,
    permissionForDelete,
    dontAllowAddDocument,
    dontShowUploadedByt,
    allowSwitchStatus,
    dontChangeType,
    allDocs,
  },
) => {
  const [docs, setDocks] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [docTypeForFilter, setDocTypeForFilter] = useState('AllDocumentsList');
  const [showUploaderBlock, setShowUploaderBlock] = useState(false);
  const dispatch = useDispatch();
  const checkSuccess = FindSuccessItem(changeStatusAction);
  const loadingStatus = FindLoad(changeStatusAction);
  const classes = screensStyle();

  useEffect(() => {
    if (checkSuccess) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(changeStatusAction));
      setSelectedItem(null);
    }
  }, [checkSuccess]);

  useEffect(() => {
    if (allDocs && allDocs) {
      setDocks(allDocs);
    }
  }, [allDocs]);

  const handleFilterChange = (ev) => {
    setDocTypeForFilter(ev?.target?.value);
    if (ev?.target?.value !== 'AllDocumentsList') {
      const newList = allDocs && allDocs.filter((i) => i.type === ev.target.value);

      setDocks(newList);
    } else {
      setDocks(allDocs);
    }
  };

  const handleShowUploadedDocs = () => {
    setShowUploaderBlock(prev => !prev);
  };


  const changeStatus = (item, type) => {
    handleChangeStatus(item, type);
    setSelectedItem(item?.id);
  };

  return (
    <div className='document-table-wrapper'>
      <div className='document-table-box'>
        {showUploaderBlock ?
          <NewDragAndDrop
            documentsTypes={documentsTypes}
            handleShowUploadedDocs={handleShowUploadedDocs}
            handleUploadFile={handleUploadFile}
            addLoadAction={addLoadAction}
          />
          :
          <div className='document-table-filter_add-button'>
            {documentsTypes &&
              <SelectInput
                name={'docType'}
                handleSelect={handleFilterChange}
                style={classes.filterInput}
                value={docTypeForFilter}
                list={[{ name: 'All Documents', id: 'AllDocumentsList' }, ...documentsTypes]}
                type={'mc'}
              />
            }

            {!dontAllowAddDocument &&
              <AddButton
                handleClick={handleShowUploadedDocs}
                text='Upload Document'
              />
            }
          </div>
        }

        <FullTable
          height={'medium'}
          head={documentsHeader({ documentsTypes, dontShowUploadedByt, allowSwitchStatus })}
          body={loadCustomerInfoBody({
            documentsTypes,
            changeStatus,
            changeStatusAction,
            handleDeleteDocument,
            deleteDocAction,
            permissionForDelete,
            dontShowUploadedByt,
            selectedItem,
            dontAllowAddDocument,
            allowSwitchStatus,
            dontChangeType,
            loadingStatus,
          })}
          list={docs || []}
          noText={'Documents'}
        />
      </div>
    </div>
  );
};

